
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Radial_Head_Fractures_Hotchkiss_Classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Radial_Head_Fractures_Hotchkiss_Classification.vue